import { useEffect, useState } from "react";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import Network from "../../utils/Network";
import { Urls } from "../../utils/Constants";

export default function FundTransfer() {

    const [errors, setErrors] = useState({});
    const [amount, setAmount] = useState("");
    const [modeOfPayment, setModeOfPayment] = useState([]);
    const [banks, setBanks] = useState([]);
    const [selectedModeOfPayment, setSelectedModeOfPayment] = useState("");
    const [selectedBank, setSelectedBank] = useState("");
    // const [minDate, setMinDate] = useState("");
    const [maxDate, setMaxDate] = useState("");
    const [remarks, setRemarks] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [file, setFile] = useState(null);
    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        fundMethod();
        bankList();
        getDates();
    }, [])
    const billerOption = [
        { value: '10', label: 'Adani Electricity Mumbai Limited' },
        { value: '54', label: 'Ajmer Vidyut Vitran Nigam Ltd' },
        { value: '75', label: 'APEPDCL - Eastern Power Distribution CO AP Ltd.' },
    ];
    const bankOption = [
        { value: '59', label: 'PUNJAB NATIONAL BANK (1845005900000022)' },
        { value: '60', label: 'AU SMALL FINANCE BANK (2302244648913363)' },
    ];
    const fundMethod = async () => {
        try {
            const localStorageDataStr = localStorage.getItem('token');
            const item = JSON.parse(localStorageDataStr);
            const response = await Network.post(Urls.baseUrlPostLogin + '/fund-request-method?api_token='+item.token);
            console.log(response);
            // if(response?.data){
            // setModeOfPayment(response?.data);
            const paymentOptions = await billerOption;//response?.data.map(item => ({
            //     value: item.method_id,
            //     label: item.payment_type.trim()
            // }));
            // console.log(paymentOptions);
            setModeOfPayment(paymentOptions);
            // }
        } catch (err) {
            console.log('error', err);
        }
    }
    const bankList = async () => {
        try {
            // const response = await Network.post(Urls.baseUrlPostLogin + '/fund-request-bank?api_token='+localStorage.getItem('token'));
            // if(response?.data){
            // setModeOfPayment(response?.data);
            const paymentOptions = await bankOption;//response?.data.map(item => ({
            //     value: item.method_id,
            //     label: item.payment_type.trim()
            // }));
            // console.log(paymentOptions);
            setBanks(paymentOptions);
            // }
        } catch (err) {
            console.log('error', err);
        }
    }
    const getDates = () => {
        const today = new Date();
        // const tenYearsAgo = new Date();
        // tenYearsAgo.setFullYear(today.getFullYear() - 10);
        // const minDate = formatDate(tenYearsAgo);
        const maxDate = formatDate(today);
        // setMinDate(minDate);
        setMaxDate(maxDate);
    };
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    }
    const submitFundTransfer = async (event) => {
        event.preventDefault();
        const newErrors = errorHandling('fundTransfer');
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            let formData = new FormData();
            const localStorageDataStr = localStorage.getItem('token');
            const item = JSON.parse(localStorageDataStr);
            formData.append("api_token", item.token);
            formData.append("bank_id", selectedBank);
            formData.append("method_id", selectedModeOfPayment);
            formData.append("amount", amount);
            formData.append("ref_id", "BANKUTR1");
            formData.append("remark", remarks);
            formData.append("payment_slip", file,"[PROXY]");
            formData.append("payment_date", selectedDate);
            try {
                const response = await Network.post(Urls.baseUrlPostLogin + '/fund-request-now', formData,true);
                console.log(response);
                if(response?.data?.status === 0){
                
                }
            } catch (err) {
                console.log('error', err);
            }
        }
    }
    const errorHandling = (type) => {
        const errors = {};
        if (type === 'fundTransfer') {
            if (!amount.trim()) {
            errors.amount = 'Amount is required';
            }else if (selectedModeOfPayment === '') {
            errors.modeOfPayment = 'Mode of payment is required';
            }else if (selectedBank === '') {
            errors.banks = 'Bank name is required';
            }else if(!selectedDate.trim()){
            errors.selectedDate = 'Payment date is required';
            }else if (!remarks.trim()) {
            errors.remarks = 'Remarks is required';
            }else if(file === null){
            errors.slip = 'slip is required';
            }else if(!isChecked){
            errors.ischecked = 'Consent is required';
            }
        }
        return errors;
    };
    return (
        <>
            <Header />
            <div className="adminuiux-wrap">
                <Sidebar />
                <main
                    className="adminuiux-content has-sidebar"
                >
                    {/*mt-4*/}
                    <div className="container " id="main-content">
                        <div className="row align-items-center">
                        </div>
                        {/* dashboard inner */}
                        <div className="midde_cont">
                            <div className="container-fluid">
                                <div className="row column_title">
                                    <div className="col-md-12">
                                        <div className="page_title d-sm-flex p-3">
                                            <h2>Fund Transfer</h2>
                                            <marquee width="90%">
                                                <h4>
                                                    <p>
                                                        <strong>
                                                            <span style={{ color: "#ffffff" }}>
                                                                <span style={{ fontSize: 24 }}>
                                                                    welcome to bill payment
                                                                </span>
                                                            </span>
                                                        </strong>
                                                    </p>
                                                </h4>
                                            </marquee>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-body">
                                        <div className="row">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div>
                                                    <div className="card bd-0 shadow-base adminuiux-card">
                                                        <div
                                                            className="card-header tx-medium bd-0 tx-white"
                                                            style={{ padding: "0.75rem 1.25rem" }}
                                                        >
                                                            Fund Transfer
                                                        </div>
                                                        <form method="post" onSubmit={submitFundTransfer}>
                                                            <div className="card-body">
                                                                <div className="form-group">
                                                                    <label>Amount</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Amount"
                                                                        value={amount}
                                                                        onChange={(e) => { setAmount(e.target.value) }}
                                                                    />
                                                                {errors.amount && (
                                                                    <span className="error-message">
                                                                        {errors.amount}
                                                                    </span>
                                                                )}
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="email-id-vertical">Mode of Payment</label>
                                                                    <select className="form-control" onChange={(e) => { setSelectedModeOfPayment(e.target.value) }}>
                                                                        <option value="">Select</option>
                                                                        {modeOfPayment.map((item) => (
                                                                            <option value={item.value}>{item.label}</option>
                                                                        ))}
                                                                    </select>
                                                                {errors.modeOfPayment && (
                                                                    <span className="error-message">
                                                                        {errors.modeOfPayment}
                                                                    </span>
                                                                )}
                                                                </div>
                                                                <div className="form-group">
                                                                    <label>To Bank Name</label>
                                                                    <select className="form-control" onChange={(e) => { setSelectedBank(e.target.value) }}>
                                                                        <option value="">Select</option>
                                                                        {banks.map((item) => (
                                                                            <option value={item.value}>{item.label}</option>
                                                                        ))}
                                                                    </select>
                                                                {errors.banks && (
                                                                    <span className="error-message">
                                                                        {errors.banks}
                                                                    </span>
                                                                )}
                                                                </div>
                                                                <div className="form-group">
                                                                    <label>Payment Date</label>
                                                                    <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        id="bene_name"
                                                                        max={maxDate}
                                                                        value={selectedDate}
                                                                        onChange={(e) => setSelectedDate(e.target.value)}
                                                                    />
                                                                {errors.selectedDate && (
                                                                    <span className="error-message">
                                                                        {errors.selectedDate}
                                                                    </span>
                                                                )}
                                                                </div>
                                                                <div className="form-group">
                                                                    <label>Remark</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="bene_name"
                                                                        placeholder="Remark"
                                                                        value={remarks}
                                                                        onChange={(e) => { setRemarks(e.target.value) }}
                                                                    />
                                                                {errors.remarks && (
                                                                    <span className="error-message">
                                                                        {errors.remarks}
                                                                    </span>
                                                                )}
                                                                </div>
                                                                <div className="form-group">
                                                                    <label>Slip</label>
                                                                    <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        onChange={handleFileChange} 
                                                                    />
                                                                {errors.slip && (
                                                                    <span className="error-message">
                                                                        {errors.slip}
                                                                    </span>
                                                                )}
                                                                </div>
                                                                <div className="row mg-t-10">
                                                                    <div className="col-sm-12 mg-t-10 mg-sm-t-0 ">
                                                                        <input type="checkbox" className="mt-4" checked={isChecked}
                                                                        onChange={(e) => setIsChecked(e.target.checked)} />
                                                                        consent
                                                                        <p>
                                                                        {errors.ischecked && (                                                                            
                                                                            <span className="error-message">
                                                                                {errors.ischecked}
                                                                                <br/>
                                                                            </span>
                                                                        )}
                                                                            I hereby confirm the deposit referred to above has been made by me on my
                                                                            behalf under my instruction I accept full responsibility from the deposit
                                                                            some and shall defend and hold harmless Kiaraa Pay technology private
                                                                            limited against any inquiries in relation to the same
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <button
                                                                    type="submit"

                                                                    className="btn btn-sm btn-primary mr-1 mb-1 waves-effect waves-light"
                                                                >
                                                                    Submit
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
}